import { computed, inject, type Signal } from '@angular/core';

import { createAccessControl } from '@shared/services/access-control/access-control.service';
import type { AdminPermission } from '@shared/services/access-control/contract/admin-permission';
import { AuthenticationService } from '@shared/services/authentication.service';

export const injectCan = (permission: AdminPermission): Signal<boolean> => {
	const authenticationService = inject(AuthenticationService);
	const accessControl = createAccessControl();

	return computed(() => accessControl.setStrategy(authenticationService.user()).can(permission));
};
